import type { FC, ReactNode } from 'react'

import { motion } from 'motion/react'

interface RevealProps {
    children: ReactNode
    className?: string
    delay?: number
    y?: number
    amount?: number
}

export const Reveal: FC<RevealProps> = ({
    children,
    className,
    delay = 0,
    y = 80,
    amount = 0.2
}): ReactNode => {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount }}
            transition={{
                default: { type: 'spring', bounce: 0.1, duration: 1, delay },
                opacity: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }
            }}
        >
            {children}
        </motion.div>
    )
}
